import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=3c532a69&scoped=true"
import script from "./CustomFields.vue?vue&type=script&lang=ts"
export * from "./CustomFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c532a69",
  null
  
)

export default component.exports